export { ReactComponent as DropdownArrow } from './svgs/dropdown-icon.svg';
